import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import { Alert, ProgressBar } from 'react-bootstrap';
import useDataApi from '../../utils/useDataApi';
import usePostApi from '../../utils/usePostApi';
import currencyConversion from '../../utils/currencyConversion';

import ScheduleD from './ScheduleD';

const type = 'schedule_d';

export default function (drupalParams) {
  const { case_uuid, canEdit, can_see_details } = drupalParams;
  const [{ data, isLoading, isError }, { setData }] = useDataApi(
    `/ir-search/query-json?query=${type}&case_uuid=${case_uuid}`,
    {}
  );
  const [editScheduleForm, setEditScheduleForm] = useState(false);

  const transformResponseToData = (item) => {
    let schedule = {};
    schedule = Array.isArray(item.queries)
      ? _.get(item, 'queries[0].schedule_d[0].text', [])
      : _.get(item, 'queries.schedule_d[0].text', []);

    return schedule;
  };

  const [{ data: savedScheduleResponse, isLoading: isLoadingSave, isError: isSaveError }, setPostData] =
    usePostApi('/scheduleform/save');

  useEffect(() => {
    if (savedScheduleResponse) setData(savedScheduleResponse.content);
  }, [savedScheduleResponse]);

  const toBoolean = (value) => /^true|yes$/i.test(value);
  const toBooleanOrBlank = (value) => (value === 'yes' ? true : value === 'no' ? false : '');

  const saveScheduleForm = (values) => {
    let { creditors = [{}] } = values;
    const { total_claims_amount_cents = 0 } = values;

    creditors = creditors.map((creditor) => ({
      collateral_amount_cents: currencyConversion.toCentsOrStr(creditor.collateral_amount_cents),
      claim_amount_cents: currencyConversion.toCentsOrStr(creditor.claim_amount_cents),
      creditor_name: creditor.creditor_name || '',

      creditor_address_street: creditor.creditor_address_street || '',
      creditor_address_city: creditor.creditor_address_city || '',
      creditor_address_state: creditor.creditor_address_state || '',
      creditor_address_zip_code: creditor.creditor_address_zip_code || '',
      creditor_address_country: creditor.creditor_address_country || '',

      creditor_email: creditor.creditor_email ? creditor.creditor_email : '',
      debt_date: creditor.debt_date || '',
      account_number_last_4_digits: creditor.account_number_last_4_digits ? creditor.account_number_last_4_digits : 0,
      property_description: creditor.property_description || '',
      lien_description: creditor.lien_description || '',
      is_creditor_an_insider: toBooleanOrBlank(creditor.is_creditor_an_insider),
      is_anyone_else_liable: toBooleanOrBlank(creditor.is_anyone_else_liable),
      is_contingent: toBoolean(creditor.is_contingent),
      is_unliquidated: toBoolean(creditor.is_unliquidated),
      is_disputed: toBoolean(creditor.is_disputed),
      has_multiple_creditor_interest: toBoolean(creditor.has_multiple_creditor_interest),
      creditor_priority: creditor.creditor_priority || '',
      has_already_specified_creditor_priority: toBoolean(creditor.has_already_specified_creditor_priority),
      creditor_priority_specified_on_line: creditor.creditor_priority_specified_on_line || '',
    }));

    const creditorsData = {
      creditors,
      total_claims_amount_cents: currencyConversion.toCents(total_claims_amount_cents),
    };

    setPostData({
      case_uuid,
      type: 'd',
      data: creditorsData,
    });

    setEditScheduleForm(false);
  };

  const toggleScheduleForm = () => {
    setEditScheduleForm(!editScheduleForm);
  };

  const onPastedData = (schedule) => {
    setEditScheduleForm(schedule);
  };

  if (isLoading || isLoadingSave) {
    return <ProgressBar now={100} bsStyle="info" label={`${isLoadingSave ? 'Saving in progress' : ''}`} active />;
  }

  if (isError || isSaveError) {
    return <Alert bsStyle="danger">There has been an error {`${isError ? 'loading' : 'saving'}`} Schedule data.</Alert>;
  }

  return (
    <ScheduleD
      schedule={transformResponseToData(data)}
      editScheduleForm={editScheduleForm}
      onPastedData={onPastedData}
      toggleScheduleForm={toggleScheduleForm}
      onSubmit={saveScheduleForm}
      canEdit={canEdit}
      can_see_details={can_see_details}
      type={type}
    />
  );
}



// WEBPACK FOOTER //
// ./src/scheduleform/schedule_d/ScheduleDContainer.jsx